import { cn } from "@universe/ui/lib/utils";
import { ReactNode } from "react";

/**
 * Wrapper that applies the whitelabel-driven logo background color.
 * Uses the --onboarding-sidebar-logo-bg CSS variable (defaults to transparent).
 * This ensures logos remain visible against any brand-colored background.
 */
export function LogoBackground({
  children,
  className,
}: {
  children: ReactNode;
  className?: string;
}) {
  return (
    <div
      className={cn("p-1 rounded-lg", className)}
      style={{
        backgroundColor: "var(--onboarding-sidebar-logo-bg, transparent)",
      }}
    >
      {children}
    </div>
  );
}
